import React, { useState, useEffect } from 'react'
import moment from 'moment'
import ShiftsManager from '../../Components/shared/ShiftsManager/ShiftsManager'
import { request, urlSearchParamsToObject } from '../../utils'
import { setLanguage } from '../../utils/locale'
import appConfig from '../../config'
import {
  mapStateToProps,
  mapDispatchToProps,
  connect
} from '../../reducers/Dispatchers'
import { setWidgetSchoolSectionsLoading } from '../../reducers/LoadingsReducer/LoadingsReducer'
import { useDispatch } from 'react-redux'

const ShiftsWidget = props => {
  const [loading, setLoading] = useState(true)
  const [institutionId, setInstitutionId] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)

  const dispatch = useDispatch()

  useEffect(() => {
    if (institutionId && props.getUser.token) {
      loadAllSectionsRelatedToInstitution()
    }
  }, [props.getUser, institutionId])

  const loadAllSectionsRelatedToInstitution = () => {
    if (!props.getWidgetSchoolSectionsLoading) {
      dispatch(setWidgetSchoolSectionsLoading(true))
    }

    props.fetchSchoolSectionsByInstitution(institutionId, props.getUser)
  }

  const loginWidgetUser = async () => {
    const { widgetUser: { username, password } } = appConfig
    const body = {
      username,
      password
    }

    try {
      const response = await request('/auth', 'POST', body)
      const { token } = response

      const { data } = await request('/user/me', 'GET', null, {
        token: token,
        switchUser: null
      })
      const loggedInUser = { ...data }
      loggedInUser.context = 'HOSPITAL'
      loggedInUser.token = token
      loggedInUser.switchUser = body.username
      props.setUser(loggedInUser)
      setLoading(false)
    } catch (err) {
      console.warn(`Error logging in: ${err.message}`)
    }
  }

  // this checks the URL for the language ("lg") param
  const setWidgetLanguage = () => {
    const { addTranslationForLanguage, setActiveLanguage, getActiveLanguage } = props

    const { lg } = urlSearchParamsToObject()
    const language = lg || 'fr'

    setLanguage({
      language,
      addTranslationForLanguage,
      setActiveLanguage,
      getActiveLanguage
    })
  }

  useEffect(() => {
    setWidgetLanguage()
    loginWidgetUser()
    setDates()
  }, [])

  const setDates = () => {
    const { start } = urlSearchParamsToObject()

    const startDate = start ? moment(start).startOf('isoWeek') : moment().startOf('isoWeek')
      .hours(0)
      .minutes(0)
      .seconds(0)
    const endDate = startDate.clone().add(3, 'weeks').endOf('isoWeek')

    setStartDate(startDate)
    setEndDate(endDate)
  }

  // this should open a new tab
  const handleOnClick = () => {
    window.open(window.location.origin, '_blank')
  }

  const renderShiftsManager = () => {
    const { institution, sector, displayMax, filter } = urlSearchParamsToObject()

    return (
      <ShiftsManager
        inWidgetMode
        start={startDate}
        institution={institution}
        studentsPerPage={displayMax}
        defaultFilter={filter ?? null}
        sector={sector}
        onWidgetCoverClick={handleOnClick}
        widgetMode
      />
    )
  }

  const renderContainer = () => {
    const { institution } = urlSearchParamsToObject()

    if (institution !== institutionId) {
      setInstitutionId(institution)
    }

    if (containerIsReady()) {
      return renderShiftsManager()
    }

    return (
      <div className='loading-ring' />
    )
  }

  const containerIsReady = () => {
    return !(loading || props.getWidgetSchoolSectionsLoading) && startDate && endDate
  }

  return (
    <div>
      {renderContainer()}
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(ShiftsWidget)
